{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2016 - 2021                               }
{            Email : info@tmssoftware.com                            }
{            Web : https://www.tmssoftware.com                       }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCHTMLEditor;

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF FMXLIB}
{$WARNINGS OFF}
{$HINTS OFF}
{$IF COMPILERVERSION > 30}
{$DEFINE DELPHIBERLIN}
{$IFEND}
{$HINTS ON}
{$WARNINGS ON}
{$ENDIF}
{$IFDEF CMNLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}
{$IFDEF VCLLIB}
{$DEFINE VCLWEBLIB}
{$ENDIF}
{$IFDEF WEBLIB}
{$DEFINE CMNWEBLIB}
{$DEFINE VCLWEBLIB}
{$ENDIF}
interface

uses
  Classes, WEBLib.TMSFNCCustomComponent, WEBLib.TMSFNCCustomControl, WEBLib.Controls,
  WEBLib.TMSFNCEditorToolBar, WEBLib.TMSFNCTypes, WEBLib.StdCtrls, WEBLib.ExtCtrls,
  WEBLib.TMSFNCHTMLText, WEBLib.TMSFNCBitmapContainer, WEBLib.Forms, WEBLib.TMSFNCGraphics,
  WEBLib.TMSFNCGraphicsTypes, WEBLib.TMSFNCEditorButton, WEBLib.TMSFNCEditorPanel
  {$IFDEF FMXLIB}
  ,FMX.Types, FMX.Memo, FMX.ListBox, FMX.ComboEdit
  {$ENDIF}
  {$IFNDEF LCLLIB}
  ,UITypes, Types
  {$ENDIF}
  ;

const
  MAJ_VER = 1; // Major version nr.
  MIN_VER = 1; // Minor version nr.
  REL_VER = 0; // Release nr.
  BLD_VER = 0; // Build nr.

  // version history
  // v1.0.0.0 : First Release
  // v1.1.0.0 : WEB and high DPI support

resourcestring
  sTMSFNCHTMLEditorOK = 'OK';
  sTMSFNCHTMLEditorCancel = 'Cancel';

type
  TTMSFNCHTMLEditor = class;
  {$IFDEF WEBLIB}
  TTMSFNCBrowserCallBackEvent = procedure(const ACallbackURLResult: string) of object;
  {$ENDIF}

  {$IFDEF FMXLIB}
  TTMSFNCHTMLEditorParent = TFmxObject;
  TTMSFNCHTMLEditorComboBox = class(TComboEdit);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  TTMSFNCHTMLEditorParent = TWinControl;
  TTMSFNCHTMLEditorComboBox = class(TComboBox);
  {$ENDIF}

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsDesktop)]
  {$ENDIF}
  TTMSFNCHTMLEditor = class(TTMSFNCCustomComponent)
  private
    FFormatToolBar: TTMSFNCEditorFormatToolBar;
    FEditToolBar: TTMSFNCEditorEditToolBar;
    FPanel, FContentPanel, FTopPanel: TTMSFNCEditorPanel;
    FButtonOk, FButtonCancel: TTMSFNCEditorButton;
    FMemo: TMemo;
    FHTMLText: TTMSFNCHTMLText;
    FText, FOriginalText: string;
    FBitmapContainer: TTMSFNCBitmapContainer;
    frm: TTMSFNCCustomDesignerForm;
    procedure SetText(const Value: String);
    procedure SetBitmapContainer(const Value: TTMSFNCBitmapContainer);
  protected
    function GetInstance: NativeUInt; override;
    procedure RegisterRuntimeClasses; override;
    procedure Notification(AComponent: TComponent; AOperation: TOperation); override;
    procedure DoOpenFile(Sender: TObject); virtual; {$IFDEF WEBLIB}async;{$ENDIF}
    {$IFNDEF WEBLIB}
    procedure DoSaveFile(Sender: TObject); virtual;
    {$ENDIF}
    procedure DoCut(Sender: TObject); virtual;
    procedure DoPaste(Sender: TObject); virtual;
    procedure DoCopy(Sender: TObject); virtual;

    procedure DoApplyFontName(Sender: TObject; AFontName: String); virtual;
    procedure DoApplyFontSize(Sender: TObject; AFontSize: Integer); virtual;
    procedure DoApplyTextColor(Sender: TObject; AColor: TTMSFNCGraphicsColor); virtual;
    procedure DoApplyBold(Sender: TObject); virtual;
    procedure DoApplyItalic(Sender: TObject); virtual;
    procedure DoInsertHyperlink(Sender: TObject); virtual;
    procedure DoInsertBitmap(Sender: TObject); virtual;
    procedure DoApplyNumbering(Sender: TObject); virtual;
    procedure DoApplyIndent(Sender: TObject); virtual;
    procedure DoApplyUnderline(Sender: TObject); virtual;
    procedure DoAlignLeft(Sender: TObject); virtual;
    procedure DoAlignCenter(Sender: TObject); virtual;
    procedure DoAlignRight(Sender: TObject); virtual;

    function HasTags(starttag,endtag:string):boolean; virtual;
    function ScanForward(starttag,endtag:string):boolean; virtual;
    function ScanBackward(starttag,endtag:string):boolean; virtual;
    procedure InsertTags(starttag,endtag:string); virtual;
    procedure RemoveTags(starttag,endtag:string); virtual;
    procedure ChangeTagProp(starttag,endtag,propname,propval:string); virtual;
    procedure DoMemoChanged(Sender: TObject); virtual;
    {$IFDEF FMXLIB}
    procedure DoMemoKeyUp(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState); virtual;
    procedure DoMemoMouseUp(Sender: TObject; Button: TMouseButton; Shift: TShiftState; X, Y: Single); virtual;
    procedure DoFormKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
    {$ENDIF}
    {$IFNDEF FMXLIB}
    procedure DoFormKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    procedure DoMemoKeyDown(Sender: TObject; var Key: Word; {%H-}Shift: TShiftState); virtual;
    procedure DoMemoKeyUp(Sender: TObject; var {%H-}Key: Word; {%H-}Shift: TShiftState); virtual;
    procedure DoMemoMouseUp(Sender: TObject; {%H-}Button: TMouseButton; {%H-}Shift: TShiftState; {%H-}X, {%H-}Y: Integer); virtual;
    {$ENDIF}
    {$IFDEF WEBLIB}
    procedure DoButtonOKClick(Sender: TObject); virtual;
    procedure DoButtonCancelClick(Sender: TObject); virtual;
    procedure IndentCallBack(const AIndent: string);
    procedure HyperlinkCallBack(const AURL: string);
    procedure ImageCallBack(const AImage: string);
    {$ENDIF}
    procedure BuildEditor(AParent: TTMSFNCHTMLEditorParent); virtual;
    procedure UpdateHTMLText; virtual;
    procedure UpdateButtons; virtual;
  public
    {$IFDEF WEBLIB}
    procedure Execute(AProc: TModalResultProc = nil);
    {$ELSE}
    function Execute: TModalResult;
    {$ENDIF}
    procedure Assign(Source: TPersistent); override;
  published
    property Text: String read FText write SetText;
    property BitmapContainer: TTMSFNCBitmapContainer read FBitmapContainer write SetBitmapContainer;
  end;

  TTMSFNCHTMLEditorForm = class(TTMSFNCCustomDesignerForm)
  {$IFDEF WEBLIB}
  private
    FHTMLEditor: TTMSFNCHTMLEditor;
  protected
    procedure Loaded; override;
    procedure LoadDFMValues; override;
  public
    constructor CreateDialogNew(AHTMLEditor: TTMSFNCHTMLEditor; ACaption: string); reintroduce; virtual;
  {$ENDIF}
  end;

implementation

uses
  WEBLib.TMSFNCUtils, WEBLib.Graphics, SysUtils, WEBLib.Dialogs, WEBLib.TMSFNCEditorsTools, WEBLib.TMSFNCEditorsToolsUI
  {$IFNDEF FMXMOBILE}
  {$IFDEF DELPHIBERLIN}
  ,FMX.DialogService.Sync
  {$ENDIF}
  {$ENDIF}
  ;

type
  {$IFNDEF WEBLIB}
  TTMSFNCHTMLEditorOpenDialog = TOpenDialog;
  {$ENDIF}
  {$IFDEF WEBLIB}
  TTMSFNCHTMLEditorOpenDialog = TWebOpenDialog;
  {$ENDIF}

{$R 'TMSFNCHTMLEditor.res'}

{ TTMSFNCHTMLEditor }

{$IFDEF WEBLIB}
procedure InsertString(const ASource: string; var AString: string; AIndex: Integer);
var
  ts: string;
begin

  ts := Copy(AString, 0, AIndex - 1);
  ts := ts + ASource;
  ts := ts + Copy(AString, AIndex, Length(AString) - (AIndex-1));

  AString := ts;
end;
{$ENDIF}

function IPos(substr,s:string):integer;
begin
  Result := Pos(UpperCase(substr), UpperCase(s));
end;

function PosFrom(selpos:integer; substr,s:string):integer;
begin
  Delete(s, 1, selpos - 1);
  Result := IPos(substr, s);
end;

function TranslateTextEx(AText: String): String;
begin
  {$IFDEF FMXLIB}
  Result := TranslateText(AText);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  Result := AText;
  {$ENDIF}
end;

function GetAveCharSize: TPoint;
var
  I: Integer;
  Buffer: string;
  g: TTMSFNCGraphics;
  sz: TSizeF;
begin
  Buffer := '';
  for I := 0 to 25 do Buffer := Buffer + Chr(I + Ord('A'));
  for I := 0 to 25 do Buffer := Buffer + Chr(I + Ord('a'));

  g := TTMSFNCGraphics.CreateBitmapCanvas;
  g.BeginScene;
  try
    sz := g.CalculateTextSize(Buffer);
    Result.X := Round(sz.cx);
    Result.Y := Round(sz.cy);
  finally
    g.EndScene;
    g.Free;
  end;

  Result.X := Result.X div 52;
end;

function InputListQuery(const ACaption, APrompt: string; SL: TStringList;
  var Value: string): Boolean;
var
  efrm: TTMSFNCCustomDesignerForm;
  Prompt: TLabel;
  Edit: TTMSFNCHTMLEditorComboBox;
  DialogUnits: TPoint;
  ButtonTop, ButtonWidth, ButtonHeight: Integer;
begin
  Result := False;

  efrm := TTMSFNCCustomDesignerForm.CreateNew(Application);
  try
    DialogUnits := GetAveCharSize;
    {$IFDEF FMXLIB}
    efrm.BorderStyle := TFmxFormBorderStyle.Single;
    efrm.Position := TFormPosition.ScreenCenter;
    efrm.Width := TTMSFNCUtils.MulDivInt(180, DialogUnits.X, 4);
    {$ENDIF}
    efrm.Caption := ACaption;
    {$IFDEF CMNWEBLIB}
    efrm.ClientWidth := TTMSFNCUtils.MulDivInt(180, DialogUnits.X, 4);
    efrm.PopupMode := pmAuto;
    efrm.Position := poScreenCenter;
    {$IFNDEF WEBLIB}
    efrm.BorderStyle := bsDialog;
    {$ENDIF}
    {$ENDIF}
    Prompt := TLabel.Create(efrm);
    Prompt.Parent := efrm;
    {$IFDEF FMXLIB}
    Prompt.Text := APrompt;
    Prompt.Position.X := TTMSFNCUtils.MulDivInt(8, DialogUnits.X, 4);
    Prompt.Position.Y := TTMSFNCUtils.MulDivInt(8, DialogUnits.Y, 8);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    Prompt.Caption := APrompt;
    Prompt.Left := TTMSFNCUtils.MulDivInt(8, DialogUnits.X, 4);
    Prompt.Top := TTMSFNCUtils.MulDivInt(8, DialogUnits.Y, 8);
    {$IFNDEF WEBLIB}
    Prompt.Constraints.MaxWidth := TTMSFNCUtils.MulDivInt(164, DialogUnits.X, 4);
    {$ENDIF}
    {$ENDIF}
    Prompt.WordWrap := True;

    Edit := TTMSFNCHTMLEditorComboBox.Create(efrm);
    Edit.Parent := efrm;
    Edit.Items.Assign(SL);
    {$IFDEF FMXLIB}
    Edit.Position.X := Prompt.Position.X;
    Edit.Position.Y := Prompt.Position.Y + Prompt.Height + 5;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    Edit.Left := Prompt.Left;
    Edit.Top := Prompt.Top + Prompt.Height + 5;
    {$ENDIF}
    Edit.Width := TTMSFNCUtils.MulDivInt(164, DialogUnits.X, 4);
    Edit.Text := Value;
    {$IFNDEF WEBLIB}
    Edit.MaxLength := 255;
    Edit.SelectAll;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    Edit.Style := csDropDown;
    {$ENDIF}

    {$IFDEF FMXLIB}
    ButtonTop := Round(Edit.Position.Y + Edit.Height + 15);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    ButtonTop := Edit.Top + Edit.Height + 15;
    {$ENDIF}
    ButtonWidth := TTMSFNCUtils.MulDivInt(50, DialogUnits.X, 4);
    ButtonHeight := TTMSFNCUtils.MulDivInt(14, DialogUnits.Y, 8);

    with TButton.Create(efrm) do
    begin
      Parent := efrm;
      {$IFDEF FMXLIB}
      Text := sTMSFNCHTMLEditorOK;
      {$ENDIF}
      {$IFDEF CMNWEBLIB}
      Caption := sTMSFNCHTMLEditorOK;
      {$ENDIF}
      ModalResult := mrOk;
      Default := True;
      SetBounds(TTMSFNCUtils.MulDivInt(38, DialogUnits.X, 4), ButtonTop, ButtonWidth,
        ButtonHeight);
    end;

    with TButton.Create(efrm) do
    begin
      Parent := efrm;
      {$IFDEF FMXLIB}
      Text := sTMSFNCHTMLEditorCancel;
      {$ENDIF}
      {$IFDEF CMNWEBLIB}
      Caption := sTMSFNCHTMLEditorCancel;
      {$ENDIF}
      ModalResult := mrCancel;
      Cancel := True;
      {$IFDEF FMXLIB}
      SetBounds(TTMSFNCUtils.MulDivInt(92, DialogUnits.X, 4), Edit.Position.Y + Edit.Height + 15,
        ButtonWidth, ButtonHeight);
      efrm.Height := Round(Position.Y + Height + 38);
      {$ENDIF}
      {$IFDEF CMNWEBLIB}
      SetBounds(TTMSFNCUtils.MulDivInt(92, DialogUnits.X, 4), Edit.Top + Edit.Height + 15,
        ButtonWidth, ButtonHeight);
      efrm.ClientHeight := Round(Top + Height + 13);
      {$ENDIF}
    end;

    if efrm.ShowModal = mrOk then
    begin
      Value := Edit.Text;
      Result := True;
    end;
  finally
    efrm.Free;
  end;
end;

procedure TTMSFNCHTMLEditor.InsertTags(starttag, endtag:string);
var
  s: string;
  ss, sl: Integer;
begin
  if not Assigned(FMemo) then
    Exit;

  ss := FMemo.SelStart + 1;
  sl := FMemo.SelLength;
  s := FMemo.Lines.Text;

  {$IFDEF WEBLIB}
  InsertString(starttag, s, ss);
  InsertString(endtag, s, ss + FMemo.SelLength + Length(starttag));
  {$ENDIF}
  {$IFNDEF WEBLIB}
  Insert(starttag, s, ss);
  Insert(endtag, s, ss + FMemo.SelLength + Length(starttag));
  {$ENDIF}

  FMemo.Lines.Text := s;
  FMemo.SelStart := ss - 1 + Length(starttag);
  FMemo.SelLength := sl;

  {$IFDEF WEBLIB}
  UpdateHTMLText;
  {$ENDIF}
end;

procedure TTMSFNCHTMLEditor.Notification(AComponent: TComponent;
  AOperation: TOperation);
begin
  inherited;
  if (AOperation = opRemove) and (AComponent = FBitmapContainer) then
    FBitmapContainer := nil;
end;

function TTMSFNCHTMLEditor.ScanBackward(starttag, endtag: string): Boolean;
var
  i: Integer;
  s: string;
begin
  Result := False;
  if not Assigned(FMemo) then
    Exit;

  i := FMemo.selstart;
  s := FMemo.lines.text;
  s := copy(s,1,i);
  Result := False;
  while (i >= 1) do
  begin
    if PosFrom(i, starttag, s) > PosFrom(i, endtag, s) then
    begin
      if pos('>' , starttag) = 0 then
        Result := pos('>', s) <> 0
      else
        Result := true;

      Break;
    end;
    dec(i);
  end;
end;

function TTMSFNCHTMLEditor.ScanForward(starttag, endtag: string): Boolean;
var
  i: Integer;
  s: string;
  st, et: Integer;
begin
  Result := False;
  if not Assigned(FMemo) then
    Exit;

  Result := False;

  i := FMemo.SelStart + 1;
  s := FMemo.Lines.Text;
  s := Copy(s, i, length(s));
  st := IPos(starttag, s);
  et := IPos(endtag, s);

  if (st = 0) and (et > 0) then
    Result := True;

  if (st > 0) and (et > 0) and (et < st) then
    Result := True;
end;

function TTMSFNCHTMLEditor.HasTags(starttag, endtag: string): boolean;
begin
  Result := ScanBackward(starttag, endtag) and ScanForward(starttag, endtag);
end;

procedure TTMSFNCHTMLEditor.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCHTMLEditor);
end;

procedure TTMSFNCHTMLEditor.RemoveTags(starttag, endtag: string);
var
  i, j, k: Integer;
  s: string;
begin
  if not Assigned(FMemo) then
    Exit;

  i := FMemo.SelStart;
  j := FMemo.SelLength;
  s := FMemo.Lines.Text;
  s := Copy(s, 1, i);
  k := i;

  while (i >= 1) do
  begin
    if PosFrom(i, starttag, s) > PosFrom(i, endtag, s) then
    begin
      s := FMemo.Lines.Text;
      Delete(s, i, Length(starttag));
      if (pos('>', starttag) = 0) then
        Delete(s, i, posfrom(i, '>', s));

      Break;
    end;
    Dec(i);
  end;

  Delete(s, PosFrom(i, endtag, s) + i - 1, Length(endtag));

  FMemo.Lines.Text := s;
  FMemo.SelStart := k - Length(starttag);
  FMemo.SelLength := j;

  {$IFDEF WEBLIB}
  UpdateHTMLText;
  {$ENDIF}
end;

procedure TTMSFNCHTMLEditor.ChangeTagProp(starttag, endtag, propname, propval: string);
var
  i, j, k, l, pp: integer;
  s, t: string;
begin
  if not Assigned(FMemo) then
    Exit;

  i := FMemo.SelStart;
  j := FMemo.SelLength;
  s := FMemo.Lines.Text;
  k := Length(s);
  l := i;
  s := Copy(s, 1, i);

  t := starttag;

  while (i >= 1) do
  begin
    if PosFrom(i, starttag, s) > PosFrom(i, endtag, s) then
    begin
      s := FMemo.Lines.Text;
      t := Copy(s, i, posfrom(i, '>', s));

      pp := IPos(' ' + propname, t);

      if (pp > 0) then
      begin
        Inc(pp);
        Delete(s, i + pp - 1, Length(propname));
        Delete(s, i + pp - 1, PosFrom(i + pp, '"', s) + 1);
        Delete(s, i + pp - 1, PosFrom(i + pp, '"', s) + 1);
      end;

      {$IFNDEF WEBLIB}
      Insert(propname +'="' + propval + '" ', s, i + Length(starttag));
      {$ENDIF}
      {$IFDEF WEBLIB}
      InsertString(propname +'="' + propval + '" ', s, i + Length(starttag));
      {$ENDIF}
      Break;
    end;
    Dec(i);
  end;

  FMemo.Lines.Text := s;
  FMemo.SelStart := l + Length(s) - k;
  FMemo.SelLength := j;
end;

procedure TTMSFNCHTMLEditor.Assign(Source: TPersistent);
begin
  if (Source is TTMSFNCHTMLEditor) then
    FText := (Source as TTMSFNCHTMLEditor).Text;  
end;

procedure TTMSFNCHTMLEditor.BuildEditor(AParent: TTMSFNCHTMLEditorParent);
begin
  if Assigned(AParent) then
  begin
    FTopPanel := TTMSFNCEditorPanel.Create(AParent);
    {$IFDEF FMXLIB}
    FTopPanel.Align := TAlignLayout.Top;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FTopPanel.Align := alTop;
    FTopPanel.Top := 0;
    {$ENDIF}
    {$IFDEF FMXLIB}
    FTopPanel.PanelPosition := eppTop;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FTopPanel.PanelPosition := eppCenter;
    {$ENDIF}
    FTopPanel.Parent := AParent;
    SetEditorBackPanelAppearance(FTopPanel);

    FPanel := TTMSFNCEditorPanel.Create(AParent);
    {$IFDEF FMXLIB}
    FPanel.Align := TAlignLayout.Bottom;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FPanel.Align := alBottom;
    {$ENDIF}
    {$IFDEF FMXLIB}
    FPanel.PanelPosition := eppBottom;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FPanel.PanelPosition := eppCenter;
    {$ENDIF}

    FPanel.Height := 37;
    FPanel.Parent := AParent;
    SetEditorBackPanelAppearance(FPanel);

    FContentPanel := TTMSFNCEditorPanel.Create(AParent);
    {$IFDEF FMXLIB}
    FContentPanel.Align := TAlignLayout.Client;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FContentPanel.Align := alClient;
    {$ENDIF}
    FContentPanel.PanelPosition := eppCenter;
    FContentPanel.Parent := AParent;
    SetEditorSubPanelAppearance(FContentPanel);

    TTMSFNCEditorToolBar.BlockBuildControls := True;

    FEditToolBar := TTMSFNCEditorEditToolBar.Create(FTopPanel);
    FEditToolBar.Appearance.Fill.Kind := gfkNone;
    FEditToolBar.Appearance.Fill.Color := gcNull;
    FEditToolBar.Appearance.Stroke.Kind := gskNone;
    FEditToolBar.DisableBackground;
    FEditToolBar.Appearance.DragGrip := False;
    FEditToolBar.Parent := FTopPanel;
    FEditToolBar.Options := FEditToolBar.Options - [etoUndo, etoRedo];
    FEditToolBar.ControlAlignment := caRight;
    FEditToolBar.Appearance.FlatStyle := True;
    FEditToolBar.OnOpenFile := DoOpenFile;
    {$IFDEF WEBLIB}
    FEditToolBar.SaveFileButton.Visible := False;
    {$ENDIF}
    {$IFNDEF WEBLIB}
    FEditToolBar.OnSaveFile := DoSaveFile;
    {$ENDIF}
    FEditToolBar.OnCut := DoCut;
    FEditToolBar.OnCopy := DoCopy;
    FEditToolBar.OnPaste := DoPaste;
    FEditToolBar.SecondSeparator.Visible := False;
    FEditToolBar.AutoSize := True;

    FEditToolBar.OptionsMenu.ShowButton := False;

    {$IFDEF VCLWEBLIB}
    FEditToolBar.AlignWithMargins := True;
    {$ENDIF}
    {$IFNDEF LCLLIB}
    FEditToolBar.Margins.Left := 5;
    FEditToolBar.Margins.Top := 5;
    FEditToolBar.Margins.Right := 5;
    FEditToolBar.Margins.Bottom := 5;
    {$ENDIF}
    {$IFDEF LCLLIB}
    FEditToolBar.BorderSpacing.Left := 5;
    FEditToolBar.BorderSpacing.Top := 5;
    FEditToolBar.BorderSpacing.Right := 5;
    FEditToolBar.BorderSpacing.Bottom := 5;
    {$ENDIF}

    FFormatToolBar := TTMSFNCEditorFormatToolBar.Create(FTopPanel);
    FFormatToolBar.Appearance.Fill.Kind := gfkNone;
    FFormatToolBar.Appearance.Fill.Color := gcNull;
    FFormatToolBar.Appearance.Stroke.Kind := gskNone;
    FFormatToolBar.DisableBackground;
    FFormatToolBar.Appearance.DragGrip := False;
    FFormatToolBar.Parent := FTopPanel;
    FFormatToolBar.Options := FFormatToolBar.Options - [ftoStrikeout, ftoBackgroundColor, ftoBullets, ftoUnindent];
    FFormatToolBar.ControlAlignment := caLeft;
    FFormatToolBar.Appearance.FlatStyle := True;
    FFormatToolBar.OnApplyBold := DoApplyBold;
    FFormatToolBar.OnApplyItalic := DoApplyItalic;
    FFormatToolBar.OnApplyNumbering := DoApplyNumbering;
    FFormatToolBar.OnApplyUnderline := DoApplyUnderline;
    FFormatToolBar.OnAlignLeft := DoAlignLeft;
    FFormatToolBar.OnAlignCenter := DoAlignCenter;
    FFormatToolBar.OnAlignRight := DoAlignRight;
    FFormatToolBar.OnApplyIndent := DoApplyIndent;
    FFormatToolBar.OnInsertHyperlink := DoInsertHyperlink;
    FFormatToolBar.OnInsertBitmap := DoInsertBitmap;
    FFormatToolBar.OnApplyFontName := DoApplyFontName;
    FFormatToolBar.OnApplyFontSize := DoApplyFontSize;
    FFormatToolBar.OnApplyTextColor := DoApplyTextColor;
    FFormatToolBar.AutoSize := True;
    FFormatToolBar.OptionsMenu.ShowButton := False;
    {$IFDEF VCLWEBLIB}
    FFormatToolBar.AlignWithMargins := True;
    {$ENDIF}
    {$IFNDEF LCLLIB}
    FFormatToolBar.Margins.Left := 5;
    FFormatToolBar.Margins.Top := 5;
    FFormatToolBar.Margins.Right := 5;
    FFormatToolBar.Margins.Bottom := 5;
    {$ENDIF}
    {$IFDEF LCLLIB}
    FFormatToolBar.BorderSpacing.Left := 5;
    FFormatToolBar.BorderSpacing.Top := 5;
    FFormatToolBar.BorderSpacing.Right := 5;
    FFormatToolBar.BorderSpacing.Bottom := 5;
    {$ENDIF}

    FTopPanel.Height := 42;

    TTMSFNCEditorToolBar.BlockBuildControls := False;

    FFormatToolBar.Build;
    FEditToolBar.Build;

    FMemo := TMemo.Create(FContentPanel);
    FMemo.Parent := FContentPanel;
    FMemo.Height := 150;
    FMemo.OnMouseUp := DoMemoMouseUp;
    {$IFDEF FMXLIB}
    FMemo.Align := TAlignLayout.Top;
    FMemo.OnChangeTracking := DoMemoChanged;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FMemo.OnKeyDown := @DoMemoKeyDown;
    FMemo.Align := alTop;
    FMemo.OnChange := @DoMemoChanged;
    FMemo.Top := 10;
    {$ENDIF}
    {$IFDEF VCLWEBLIB}
    FMemo.AlignWithMargins := True;
    {$ENDIF}
    {$IFNDEF LCLLIB}
    FMemo.Margins.Left := 5;
    FMemo.Margins.Top := 5;
    FMemo.Margins.Right := 5;
    FMemo.Margins.Bottom := 5;
    {$ENDIF}
    {$IFDEF LCLLIB}
    FMemo.BorderSpacing.Left := 5;
    FMemo.BorderSpacing.Top := 5;
    FMemo.BorderSpacing.Right := 5;
    FMemo.BorderSpacing.Bottom := 5;
    {$ENDIF}

    FHTMLText := TTMSFNCHTMLText.Create(FContentPanel);
    FHTMLText.AdaptToStyle := True;
    FHTMLText.Parent := FContentPanel;
    FHTMLText.ControlAlignment := caClient;
    FHTMLText.HorizontalTextAlign := gtaLeading;
    FHTMLText.VerticalTextAlign := gtaLeading;
    FHTMLText.BitmapContainer := BitmapContainer;
    FHTMLText.WordWrapping := True;
    {$IFDEF VCLWEBLIB}
    FHTMLText.AlignWithMargins := True;
    {$ENDIF}
    {$IFNDEF LCLLIB}
    FHTMLText.Margins.Left := 5;
    FHTMLText.Margins.Top := 0;
    FHTMLText.Margins.Right := 5;
    FHTMLText.Margins.Bottom := 5;
    {$ENDIF}
    {$IFDEF LCLLIB}
    FHTMLText.BorderSpacing.Left := 5;
    FHTMLText.BorderSpacing.Top := 0;
    FHTMLText.BorderSpacing.Right := 5;
    FHTMLText.BorderSpacing.Bottom := 5;
    {$ENDIF}
    SetEditorHTMLTextAppearance(FHTMLText);

    FButtonCancel := TTMSFNCEditorButton.Create(FPanel);
    FButtonCancel.ModalResult := mrCancel;
    FButtonCancel.Parent := FPanel;
    FButtonCancel.Text := TranslateTextEx(sTMSFNCHTMLEditorCancel);
    {$IFDEF FMXLIB}
    FButtonCancel.Align := TAlignLayout.Right;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FButtonCancel.Align := alRight;
    FButtonCancel.Left := 100;
    {$IFDEF VCLWEBLIB}
    FButtonCancel.AlignWithMargins := True;
    {$ENDIF}
    {$ENDIF}
    {$IFDEF LCLLIB}
    FButtonCancel.BorderSpacing.Right := 5;
    FButtonCancel.BorderSpacing.Top := 5;
    FButtonCancel.BorderSpacing.Bottom := 5;
    FButtonCancel.BorderSpacing.Left := 5;
    {$ENDIF}
    {$IFNDEF LCLLIB}
    FButtonCancel.Margins.Right := 5;
    FButtonCancel.Margins.Top := 5;
    FButtonCancel.Margins.Bottom := 5;
    FButtonCancel.Margins.Left := 5;
    {$ENDIF}
    {$IFDEF WEBLIB}
    FButtonCancel.OnClick := DoButtonCancelClick;
    {$ENDIF}
    SetEditorCancelButtonAppearance(FButtonCancel);

    FButtonOK := TTMSFNCEditorButton.Create(FPanel);
    FButtonOK.ModalResult := mrOk;
    FButtonOK.Parent := FPanel;
    FButtonOK.Text := TranslateTextEx(sTMSFNCHTMLEditorOK);
    {$IFDEF FMXLIB}
    FButtonOk.Align := TAlignLayout.Right;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FButtonOk.Align := alRight;
    FButtonOk.Left := 99;
    {$IFDEF VCLWEBLIB}
    FButtonOK.AlignWithMargins := True;
    {$ENDIF}
    {$ENDIF}
    {$IFNDEF LCLLIB}
    FButtonOK.Margins.Right := 0;
    FButtonOK.Margins.Top := 5;
    FButtonOK.Margins.Bottom := 5;
    FButtonOK.Margins.Left := 5;
    {$ENDIF}
    {$IFDEF LCLLIB}
    FButtonOK.BorderSpacing.Right := 0;
    FButtonOK.BorderSpacing.Top := 5;
    FButtonOK.BorderSpacing.Bottom := 5;
    FButtonOK.BorderSpacing.Left := 5;
    {$ENDIF}
    {$IFDEF WEBLIB}
    FButtonOK.OnClick := DoButtonOKClick;
    {$ENDIF}
    SetEditorOKButtonAppearance(FButtonOk);

    if Assigned(FMemo) then
      FMemo.Text := FText;
    if Assigned(FHTMLText) then
      FHTMLText.Text := FText;

    UpdateButtons;

    SetEditorToolBarAppearance(FEditToolBar);
    SetEditorToolBarAppearance(FFormatToolBar);
  end;
end;

{$IFDEF WEBLIB}
procedure TTMSFNCHTMLEditor.DoButtonOKClick(Sender: TObject);
begin
  if Assigned(frm) then
    frm.ModalResult := mrOK;
end;

procedure TTMSFNCHTMLEditor.DoButtonCancelClick(Sender: TObject);
begin
  if Assigned(frm) then
    frm.ModalResult := mrCancel;
end;
{$ENDIF}

procedure TTMSFNCHTMLEditor.DoAlignCenter(Sender: TObject);
begin
  if not Assigned(FMemo) then
    Exit;

  if HasTags('<P align="right">','</P>') then
    RemoveTags('<P align="right">','</P>');
  if HasTags('<P align="left">','</P>') then
    RemoveTags('<P align="left">','</P>');

  InsertTags('<P align="center">','</P>');
end;

procedure TTMSFNCHTMLEditor.DoAlignLeft(Sender: TObject);
begin
  if not Assigned(FMemo) then
    Exit;

  if HasTags('<P align="right">','</P>') then
    RemoveTags('<P align="right">','</P>');
  if HasTags('<P align="center">','</P>') then
    RemoveTags('<P align="center">','</P>');

  InsertTags('<P align="left">','</P>');
end;

procedure TTMSFNCHTMLEditor.DoAlignRight(Sender: TObject);
begin
  if not Assigned(FMemo) then
    Exit;

  if HasTags('<P align="center">','</P>') then
    RemoveTags('<P align="center">','</P>');
  if HasTags('<P align="left">','</P>') then
    RemoveTags('<P align="left">','</P>');

  InsertTags('<P align="right">','</P>');
end;

procedure TTMSFNCHTMLEditor.DoApplyBold(Sender: TObject);
begin
  if not Assigned(FMemo) then
    Exit;

  if not HasTags('<B>','</B>') then
    InsertTags('<B>','</B>')
  else
    RemoveTags('<B>','</B>');
end;

procedure TTMSFNCHTMLEditor.DoApplyFontName(Sender: TObject; AFontName: String);
begin
  if not Assigned(FMemo) then
    Exit;

  if HasTags('<FONT ','</FONT>') then
    ChangeTagProp('<FONT ','</FONT>','face',AFontName)
  else
    InsertTags('<FONT face="'+AFontName+'">','</FONT>');

  FMemo.setfocus;
end;

procedure TTMSFNCHTMLEditor.DoApplyFontSize(Sender: TObject;
  AFontSize: Integer);
begin
  if not Assigned(FMemo) then
    Exit;

  if HasTags('<FONT ','</FONT>') then
    ChangeTagProp('<FONT ','</FONT>',' size',IntToStr(AFontSize))
  else
    InsertTags('<FONT size="'+IntToStr(AFontSize)+'">','</FONT>');

  FMemo.setfocus;
end;

procedure TTMSFNCHTMLEditor.DoApplyIndent(Sender: TObject);
  {$IFNDEF FMXMOBILE}
  {$IFDEF DELPHIBERLIN}
var
  t: array of string;
  {$ELSE}
var
  t: string;
  {$ENDIF}
  {$IFDEF WEBLIB}
  cb: TTMSFNCBrowserCallBackEvent;
  {$ENDIF}
  {$ENDIF}
begin
  if not Assigned(FMemo) then
    Exit;

  {$IFNDEF FMXMOBILE}
  {$IFDEF DELPHIBERLIN}
  SetLength(t, 1);
  t[0] := '0';
  if TDialogServiceSync.InputQuery('Set indent', ['Indent value'],t) then
    InsertTags('<IND x="'+t[0]+'"/>','');
  {$ELSE}
  t := '0';
  {$IFDEF WEBLIB}
  if Assigned(VSIDE) then
  begin
    cb := IndentCallBack;
    asm
      if (pas["WEBLib.Forms"].VSIDE)
      {
        pas["WEBLib.Forms"].VSIDE.Prompt("Set indent","Indent value", cb);
      }
    end;
  end
  else {$ENDIF} if InputQuery('Set indent', 'Indent value',t) then
    InsertTags('<IND x="'+t+'"/>','');
  {$ENDIF}
  {$ENDIF}
end;

procedure TTMSFNCHTMLEditor.DoApplyItalic(Sender: TObject);
begin
  if not Assigned(FMemo) then
    Exit;

  if not HasTags('<I>','</I>') then
    InsertTags('<I>','</I>')
  else
    RemoveTags('<I>','</I>');
end;

procedure TTMSFNCHTMLEditor.DoApplyNumbering(Sender: TObject);
var
  i: integer;
  sl: TStringList;
begin
  if not Assigned(FMemo) then
    Exit;

  if FMemo.SelLength = 0 then
    InsertTags('<LI>','')
  else
  begin
    if not HasTags('<UL>','</UL>') then
    begin
      InsertTags('<UL>','</UL>');

      if not HasTags('<LI>','</LI>') then
      begin
        sl := TStringList.Create;
        {$IFNDEF WEBLIB}
        sl.Text := FMemo.SelText;
        {$ENDIF}
        {$IFDEF WEBLIB}
        sl.Text := Copy(FMemo.Text, FMemo.SelStart, FMemo.SelLength);
        {$ENDIF}

        if sl.Count > 1 then
        begin
          for i := 0 to sl.Count - 1 do
            sl.Strings[i] := '<LI>' + sl.Strings[i];

          FMemo.SelStart := Pos(FMemo.Lines.Text, sl.Text);
          FMemo.SelLength := Length(sl.Text);
        end;
        sl.Free;
      end;

    end
    else
      RemoveTags('<UL>','</UL>');
  end;
end;

procedure TTMSFNCHTMLEditor.DoApplyTextColor(Sender: TObject;
  AColor: TTMSFNCGraphicsColor);
var
  l: Integer;
begin
  if not Assigned(FMemo) then
    Exit;

  {$IFDEF CMNWEBLIB}
  l := ColorToRGB(AColor);
  {$ENDIF}
  {$IFDEF FMXLIB}
  l := TAlphaColorRec.ColorToRGB(AColor);
  {$ENDIF}

  l := ((l and $FF0000) shr 16) or ((l and $FF) shl 16) or (l and $FF00);
  if HasTags('<FONT ','</FONT>') then
    ChangeTagProp('<FONT ','</FONT>','color','#'+IntToHex(l,6))
  else
    InsertTags('<FONT color="#'+IntToHex(l,6)+'">','</FONT>');
end;

procedure TTMSFNCHTMLEditor.DoApplyUnderline(Sender: TObject);
begin
  if not Assigned(FMemo) then
    Exit;

  if not HasTags('<U>','</U>') then
    InsertTags('<U>','</U>')
  else
    RemoveTags('<U>','</U>');
end;

procedure TTMSFNCHTMLEditor.DoCopy(Sender: TObject);
begin
  if not Assigned(FMemo) then
    Exit;
  {$IFNDEF WEBLIB}
    TTMSFNCClipBoard.SetText(FMemo.SelText);
  {$ENDIF}
  {$IFDEF WEBLIB}
    TTMSFNCClipBoard.SetText(Copy(FMemo.Text, FMemo.SelStart, FMemo.SelLength));
  {$ENDIF}
  
end;

procedure TTMSFNCHTMLEditor.DoCut(Sender: TObject);
var
  s: String;
  ss: Integer;
begin
  if not Assigned(FMemo) then
    Exit;
  {$IFNDEF WEBLIB}
    TTMSFNCClipBoard.SetText(FMemo.SelText);
  {$ENDIF}
  {$IFDEF WEBLIB}
    TTMSFNCClipBoard.SetText(Copy(FMemo.Text, FMemo.SelStart, FMemo.SelLength));
  {$ENDIF}
  s := FMemo.Text;
  ss := FMemo.SelStart;
  Delete(s, FMemo.SelStart + 1, FMemo.SelLength);
  FMemo.Text := s;
  FMemo.SelStart := ss;
end;

{$IFNDEF FMXLIB}
procedure TTMSFNCHTMLEditor.DoFormKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
{$ENDIF}
{$IFDEF FMXLIB}
procedure TTMSFNCHTMLEditor.DoFormKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
{$ENDIF}
begin
  inherited;
  if (Sender is TTMSFNCCustomDesignerForm) then
  begin
    if Key = KEY_ESCAPE then
    begin
      (Sender as TTMSFNCCustomDesignerForm).Close;
    end;
  end;
end;

procedure TTMSFNCHTMLEditor.DoInsertBitmap(Sender: TObject);
var
  t: string;
  sl: TStringList;
  i: integer;
  {$IFDEF WEBLIB}
  cb: TTMSFNCBrowserCallBackEvent;
  {$ENDIF}
begin
  if not Assigned(FMemo) then
    Exit;

  {$IFDEF WEBLIB}
  if Assigned(VSIDE) then
  begin
    cb := ImageCallBack;
    asm
      if (pas["WEBLib.Forms"].VSIDE)
      {
        pas["WEBLib.Forms"].VSIDE.Prompt("Image","Image bitmap name", cb);
      }
    end;
  end
  else 
  begin
  {$ENDIF} 
  t := '';

  sl := TStringList.Create;

  if Assigned(BitmapContainer) then
  begin
    for i := 0 to BitmapContainer.Items.Count - 1 do
    begin
      sl.Add(BitmapContainer.Items[i].Name);
    end;
  end;

  try
    if InputListQuery('Image', 'Image reference',sl,t) then
      InsertTags('<IMG src="'+t+'"/>','');
  finally
    sl.Free;
  end;
  {$IFDEF WEBLIB}
  end;
  {$ENDIF}
end;

procedure TTMSFNCHTMLEditor.DoInsertHyperlink(Sender: TObject);
  {$IFNDEF FMXMOBILE}
  {$IFDEF DELPHIBERLIN}
var
  url: array of string;
  {$ELSE}
var
  url: string;
  {$ENDIF}
  {$IFDEF WEBLIB}
  cb: TTMSFNCBrowserCallBackEvent;
  {$ENDIF}
  {$ENDIF}
begin
  if not Assigned(FMemo) then
    Exit;

  if HasTags('<A ','</A>') then
    RemoveTags('<A ','</A>');

  {$IFNDEF FMXMOBILE}
  {$IFDEF DELPHIBERLIN}
  SetLength(url, 1);
  if TDialogServiceSync.InputQuery('Hyperlink',['URL'],url) then
    InsertTags('<A href="'+url[0]+'">','</A>');
  {$ELSE}
  url := '';
  {$IFDEF WEBLIB}
  if Assigned(VSIDE) then
  begin
    cb := HyperlinkCallBack;
    asm
      if (pas["WEBLib.Forms"].VSIDE)
      {
        pas["WEBLib.Forms"].VSIDE.Prompt("Hyperlink","URL", cb);
      }
    end;
  end
  else {$ENDIF} if InputQuery('Hyperlink','URL',url) then
    InsertTags('<A href="'+url+'">','</A>');
  {$ENDIF}
  {$ENDIF}

  FMemo.SetFocus;
end;

procedure TTMSFNCHTMLEditor.DoMemoChanged(Sender: TObject);
begin
  UpdateHTMLText;
end;

procedure TTMSFNCHTMLEditor.DoOpenFile(Sender: TObject);
var
  od: TTMSFNCHTMLEditorOpenDialog;
  {$IFDEF WEBLIB}
  res: boolean;
  str: string;
  {$ENDIF}
begin
  if not Assigned(FMemo) then
    Exit;

  od := TTMSFNCHTMLEditorOpenDialog.Create(Self);
   try
    {$IFNDEF WEBLIB}
    od.Filter := 'Text files|*.txt';
    od.FilterIndex := 0;
    {$ENDIF}
    {$IFNDEF WEBLIB}
    if od.Execute then
    {$ENDIF}
    {$IFDEF WEBLIB}
    res := await(Boolean, od.Perform);
    if res then
    {$ENDIF}
    begin
      {$IFDEF WEBLIB}
      if (od.Files.Count > 0) then
      begin
        str := await(string, od.Files[0].FileAsText);
        FMemo.Text := str;
      
        UpdateHTMLText;
      end;
      {$ENDIF}
      {$IFNDEF WEBLIB}
      FMemo.Lines.LoadFromFile(od.FileName);
      {$ENDIF}
    end;
  finally
    od.Free;
  end;
end;

procedure TTMSFNCHTMLEditor.DoPaste(Sender: TObject);
var
  s, cs: string;
  ss, sl: Integer;
begin
  if not Assigned(FMemo) then
    Exit;

  cs := TTMSFNCClipBoard.GetText;
  if cs <> '' then
  begin
    ss := FMemo.SelStart + 1;
    sl := FMemo.SelLength;
    s := FMemo.Lines.Text;

    {$IFNDEF WEBLIB}
    Insert(cs, s, ss);
    {$ENDIF}
    {$IFDEF WEBLIB}
    InsertString(cs, s, ss);
    {$ENDIF}

    FMemo.Lines.Text := s;
    FMemo.SelStart := ss - 1 + Length(cs);
    FMemo.SelLength := sl;
  end;
end;

{$IFNDEF WEBLIB}
procedure TTMSFNCHTMLEditor.DoSaveFile(Sender: TObject);
var
  sd: TSaveDialog;
  fe,fn: string;
begin
  if not Assigned(FMemo) then
    Exit;

  sd := TSaveDialog.Create(Self);
  sd.Filter := 'Text files|*.txt';
  sd.DefaultExt := 'txt';
  sd.Options := sd.Options + [TOpenOption.ofOverwritePrompt];
  sd.FilterIndex := 0;
  try
    if sd.Execute then
    begin
      fn := sd.FileName;

      fe := Uppercase(ExtractFileExt(sd.FileName));

      if (fe = '') then
      begin
        if sd.FilterIndex = 0 then
          fn := fn + '.txt';
      end
      else
      begin
        if fe = '.TXT' then
          sd.FilterIndex := 0;
      end;

      FMemo.Lines.SaveToFile(fn);
    end;
  finally
    sd.Free;
  end;
end;
{$ENDIF}

{$IFDEF FMXLIB}
procedure TTMSFNCHTMLEditor.DoMemoKeyUp(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
begin
  UpdateButtons;
end;

procedure TTMSFNCHTMLEditor.DoMemoMouseUp(Sender: TObject; Button: TMouseButton; Shift: TShiftState; X: Single; Y: Single);
begin
  UpdateButtons;
end;
{$ENDIF}
{$IFDEF CMNWEBLIB}
procedure TTMSFNCHTMLEditor.DoMemoKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
begin
  UpdateButtons;
end;

procedure TTMSFNCHTMLEditor.DoMemoMouseUp(Sender: TObject; Button: TMouseButton; Shift: TShiftState; X: Integer; Y: Integer);
begin
  UpdateButtons;
end;

procedure TTMSFNCHTMLEditor.DoMemoKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if not Assigned(FMemo) then
    Exit;

  if (Key = ord('A')) and (ssCtrl in Shift) then
  {$IFNDEF WEBLIB}
  FMemo.SelectAll;
  {$ENDIF}    
  {$IFDEF WEBLIB}
  begin
    FMemo.SelStart := 0;
    FMemo.SelLength := Length(FMemo.Text);
  end;
  {$ENDIF}
end;

{$ENDIF}

{$IFDEF WEBLIB}
procedure TTMSFNCHTMLEditor.Execute(AProc: TModalResultProc = nil);
{$ELSE}
function TTMSFNCHTMLEditor.Execute: TModalResult;
{$ENDIF}
begin
  FOriginalText := Text;
  {$IFDEF WEBLIB}
  frm := TTMSFNCHTMLEditorForm.CreateDialogNew(Self, 'HTML Editor');
  {$ELSE}
  frm := TTMSFNCHTMLEditorForm.CreateNew(Application);
  frm.Caption := 'HTML Editor';
  {$ENDIF}
  frm.Width := 750;
  frm.Height := 400;
  {$IFDEF FMXLIB}
  frm.Position := TFormPosition.ScreenCenter;
  frm.Fill.Kind := TBrushKind.Solid;
  if IsLightTheme then
    frm.Fill.Color := EDITORSUBBACKCOLORLIGHT
  else
    frm.Fill.Color := EDITORSUBBACKCOLORDARK;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  frm.Position := poScreenCenter;
  {$IFNDEF WEBLIB}
  frm.KeyPreview := True;
  {$ENDIF}
  {$ENDIF}
  frm.OnKeyDown := @DoFormKeyDown;
  {$IFNDEF WEBLIB}
  BuildEditor(frm);
  frm.ActiveControl := FMemo;
  {$ENDIF}
  TTMSFNCUtils.ScaleForCurrentDPI(frm);
  {$IFNDEF WEBLIB}
  Result := frm.ShowModal;
  if (Result <> mrOk) then
  begin
    Text := FOriginalText;
  end;
  frm.Free;
  {$ELSE}
  frm.ShowModal(
  procedure(AResult: TModalResult)
  begin
    if (AResult <> mrOk) then
    begin
      Text := FOriginalText;
    end;
    frm := nil;
    if Assigned(AProc) then
      AProc(AResult);
  end);
  {$ENDIF}
end;

function TTMSFNCHTMLEditor.GetInstance: NativeUInt;
begin
  Result := HInstance;
end;

procedure TTMSFNCHTMLEditor.SetBitmapContainer(
  const Value: TTMSFNCBitmapContainer);
begin
  FBitmapContainer := Value;
  if Assigned(FHTMLText) then
    FHTMLText.BitmapContainer := FBitmapContainer;
end;

procedure TTMSFNCHTMLEditor.SetText(const Value: String);
begin
  FText := Value;
  FOriginalText := FText;
  if Assigned(FMemo) then
    FMemo.Text := FText;
  if Assigned(FHTMLText) then
    FHTMLText.Text := FText;
end;

{$IFDEF WEBLIB}
procedure TTMSFNCHTMLEditor.IndentCallBack(const AIndent: string);
begin
  InsertTags('<IND x="' + AIndent + '"/>', '');
end;

procedure TTMSFNCHTMLEditor.HyperlinkCallBack(const AURL: string);
begin
  InsertTags('<A href="' + AURL + '">', '</A>');
end;

procedure TTMSFNCHTMLEditor.ImageCallBack(const AImage: string);
begin
  InsertTags('<IMG src="'+ AImage +'"/>','');
end;
{$ENDIF}

procedure TTMSFNCHTMLEditor.UpdateButtons;
begin
  if not Assigned(FFormatToolBar) or not Assigned(FEditToolBar) or not Assigned(FMemo) then
    Exit;

  FEditToolBar.CopyButton.Enabled := FMemo.SelLength > 0;
  FEditToolBar.CutButton.Enabled := FMemo.SelLength > 0;
  FEditToolBar.PasteButton.Enabled := TTMSFNCClipBoard.HasFormat(TTMSFNCClipBoardFormat.cfText);
  FFormatToolBar.BoldButton.DownState := HasTags('<B>','</B>');
  FFormatToolBar.ItalicButton.DownState := HasTags('<I>','</I>');
  FFormatToolBar.UnderlineButton.DownState := HasTags('<U>','</U>');
  FFormatToolBar.AlignLeftButton.DownState := not HasTags('<P align="right">','</P>') and not HasTags('<P align="center">','</P>');
  FFormatToolBar.AlignRightButton.DownState := HasTags('<P align="right">','</P>');
  FFormatToolBar.AlignCenterButton.DownState := HasTags('<P align="center">','</P>');
  FFormatToolBar.AlignLeftButton.DownState := HasTags('<P align="left">','</P>');
  FFormatToolBar.HyperlinkButton.DownState := HasTags('<A ','</A>');
  FFormatToolBar.NumberingButton.DownState := HasTags('<UL>','</UL>');
end;

procedure TTMSFNCHTMLEditor.UpdateHTMLText;
begin
  if Assigned(FMemo) then
  begin
    FText := FMemo.Text;
    if Assigned(FHTMLText) then
      FHTMLText.Text := FText;
  end;
end;


{$IFDEF WEBLIB}

{ TTMSFNCHTMLEditorForm }

constructor TTMSFNCHTMLEditorForm.CreateDialogNew(AHTMLEditor: TTMSFNCHTMLEditor; ACaption: string);
begin
  FHTMLEditor := AHTMLEditor;
  inherited CreateDialogNew(ACaption);
end;

procedure TTMSFNCHTMLEditorForm.LoadDFMValues;
begin
  inherited LoadDFMValues;
  if Assigned(FHTMLEditor) then
  begin
    FHTMLEditor.BuildEditor(Self);
    if Assigned(FHTMLEditor.FMemo) then
      ActiveControl := FHTMLEditor.FMemo;
  end;
end;

procedure TTMSFNCHTMLEditorForm.Loaded;
var
  css: string;
begin
  inherited;

  css := Application.IDECSS;

  if (css <> '') then
  begin
    AddCSS('IDECSS', css);
    ElementClassName := 'IDEBkg';
    CaptionElement['class'] := 'IDECaption IDEFont';
  end;
end;

{$ENDIF}

end.
